const EmptyData2 = () => {
  return (
    <svg
      width="180"
      height="180"
      viewBox="0 0 180 180"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M114.998 133.984L111.998 107.984L89.998 111.984V141.984L114.998 133.984Z"
        fill="#E1E1E4"
      />
      <path
        d="M64.998 133.984L67.998 107.984L49.998 111.984L32 139.984L64.998 133.984Z"
        fill="#E1E1E4"
      />
      <path
        d="M111.998 107.984L114.998 133.984L148 139.984L129.998 111.984L111.998 107.984Z"
        fill="#F3F3F4"
      />
      <path
        d="M67.998 107.984L64.998 133.984L89.998 141.984V111.984L67.998 107.984Z"
        fill="#F3F3F4"
      />
      <path
        d="M56 75.1223C56 56.716 71.878 41.9844 90 41.9844C108.122 41.9844 124 56.716 124 75.1223C124 88.0658 114.765 99.5184 107.454 107.253C102.942 112.028 95.4178 118.288 90 121.981C84.5714 118.274 77.0709 112.044 72.5411 107.251C65.2306 99.5161 56 88.0658 56 75.1223Z"
        fill="#BBBBBD"
      />
      <path
        d="M75.5 75.9844C75.5 68.2524 82.2681 61.4844 90 61.4844C97.7319 61.4844 104.5 68.2524 104.5 75.9844C104.5 83.7163 97.7319 89.9844 90 89.9844C82.2681 89.9844 75.5 83.7163 75.5 75.9844Z"
        fill="#F8F8F9"
      />
    </svg>
  )
}

export default EmptyData2
